import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { FormArgument } from '@/models/client/message'

const URL = '/rest/customer/feedback/customer-messa'

export default {
  list ({form}, cb) {
    let postData = convert.toStringify(form, FormArgument)
    http.post(URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }}).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/message.js